import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import Form from "components/Form";
import { fetchDataFromApi } from "@Utils";
import GrievanceComment from "./Comment/GrievanceComment";
import {
  GRIEVANCE_URL,
  INTERNAL_GRIEVANCE_STATUS,
  URLS,
  GRIEVANCE_URGENCY_LEVELS,
  GRIEVANCE_TYPE,
  GRIEVANCE_ASSIGNEE,
  TRANSLATION_DISCLAIMER_MESSAGE,
} from "configs/constants";
import GrievanceTranslation from "./Translation/GrievanceTranslation";
import GrievanceClosedDetails from "./GrievanceClosedDetails";

const initialValues = {
  internal_status: "",
  supporting_document: null,
  remarks: "",
  urgency_level: "",
  grievance_type: "",
  assignee: [],
};

const GrievanceDetail = () => {
  const [grievanceChoices, setGrievanceChoices] = useState([]);

  const params = useParams();

  useEffect(() => {
    const config = {
      params: {
        grievance_id: params.id,
      },
    };
    fetchDataFromApi(
      INTERNAL_GRIEVANCE_STATUS,
      setGrievanceChoices,
      false,
      config
    );
  }, []);

  const formButtons = ["cancel"];

  const formFields = [
    { type: "title", title: "Employee Details" },
    {
      type: "renderonly",
      label: "Employee ID",
      key: "user.employee_id",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Employee Name",
      key: "user.name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Mobile Number",
      key: "user.mobile_number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Supervisor",
      key: "user.supervisor",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Nationality",
      key: "user.nationality",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Company",
      key: "user.company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Zone",
      key: "user.zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Region",
      key: "user.region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Estate",
      key: "user.estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Division",
      key: "user.division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Block",
      key: "user.block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "renderonly", 
      label: "Is Anonymous?", 
      key: "is_anonymous",
      valueType: "boolean",
      yesValue: "Yes",
      noValue: "No",
      supportedTypes: ["Anonymous Information is hidden if your Role has no access to Anonymous details"],
      infobutton: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

    },

    { type: "title", title: "Grievance Details" },
    {
      type: "renderonly",
      label: "Grievance ID",
      key: "grievance_id",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Date and Time",
      key: "created_at",
      valueType: "date_time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Mobile Date and Time",
      key: "mobile_date_time",
      valueType: "date_time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Type",
      key: "is_audio_message",
      valueType: "boolean",
      yesValue: "Audio",
      noValue: "Text",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Audio",
      key: "audio_file",
      valueType: "audioLink",
      linkWrapper: "grievance_id",
      linkWrapperText: "Audio-Link",
      renderKey: "is_audio_message",
      renderValue: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Grievance Text",
      key: "text_message",
      renderKey: "is_audio_message",
      renderValue: false,
      gridSize: { xs: 12 },
    },
    {
      type: "renderonly",
      name: "internal_status",
      key: "internal_status",
      label: "Status",
      outerOptions: grievanceChoices,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "supporting_document",
      key: "supporting_document",
      label: "Supporting Document",
      supportedTypes: ["png", "jpg", "gif", "pdf", "doc", "docx"],
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "assignee_name",
      key: "assignee_name",
      label: "Assignee",
      proxyUrl: GRIEVANCE_ASSIGNEE,
      paginated: false,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "urgency_level",
      key: "urgency_level",
      label: "Urgency Level",
      proxyUrl: GRIEVANCE_URGENCY_LEVELS,
      paginated: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "grievance_type",
      key: "grievance_type",
      label: "Grievance Type",
      proxyUrl: GRIEVANCE_TYPE,
      paginated: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      size: "medium",
      name: "remarks",
      key: "remarks",
      label: "Remarks",
      variant: "outlined",
      multiline: true,
      rows: 3,
      gridSize: { xs: 12, sm: 12 },
    },

    {
      type: "title",
      title: "Closed Details",
      renderKey: "internal_status",
      renderWithMultipleValuesOfSameKey: ["Pending Close", "Closed"],
      renderWithUnchangeableState: true,
    },
    {
      type: "component",
      component: GrievanceClosedDetails,
      gridSize: { xs: 12 },
      renderKey: "internal_status",
      renderWithMultipleValuesOfSameKey: ["Pending Close", "Closed"],
      renderWithUnchangeableState: true,
      passValueWithKey: [
        "pending_close_by_name",
        "pending_close_at",
        "closed_by_name",
        "closed_at",
      ],
    },

    {
      type: "title",
      title: "Translation Details",
      showInfoIcon: true,
      infoContent: TRANSLATION_DISCLAIMER_MESSAGE,
    },
    {
      type: "component",
      component: GrievanceTranslation,
      passValueWithKey: [
        "allowed_translation_count",
        "translated_text",
        "internal_status",
      ],
      gridSize: { xs: 12 },
      renderOnly: true,
    },

    { type: "title", title: "Comment" },
    {
      type: "component",
      component: GrievanceComment,
      key: "comments",
      passValueWithKey: "user_language",
      gridSize: { xs: 12 },
      renderOnly: true,
    },
  ];

  return (
    <>
      <Form
        initialValues={initialValues}
        buttonPosition={25}
        submitUrl={GRIEVANCE_URL}
        formFields={formFields}
        listRoute={URLS.GRIEVANCE_LIST}
        formButtons={formButtons}
        formTitle="Grievance"
        noListButton
        isMultipart
        outerConfig={{ params: { bo_request: true } }}
      />
    </>
  );
};

export default GrievanceDetail;
